import { render, staticRenderFns } from "./BookResults.vue?vue&type=template&id=b485cdf4&scoped=true&"
import script from "./BookResults.vue?vue&type=script&lang=js&"
export * from "./BookResults.vue?vue&type=script&lang=js&"
import style0 from "./BookResults.vue?vue&type=style&index=0&id=b485cdf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b485cdf4",
  null
  
)

export default component.exports